import { BaseAPI } from './BaseAPI.js'
import { DoNotDial } from '../types/index.js'

export default class DoNotDialApi extends BaseAPI<DoNotDial> {
  override get resource(): string {
    return '/doNotDial'
  }

  public async uploadFile(file: any) {
    const formData = new FormData()

    formData.append('import_file', file)
    await this._client.post(`${this.resource}/fileUpload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  public async upload(
    numbers: string,
    campaignId: string | null,
  ): Promise<void> {
    const formData = new FormData()

    formData.append('phone_numbers', numbers)
    if (campaignId) {
      formData.append('campaign_id', campaignId)
    }
    await this._client.post(`${this.resource}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }
}
